// material
import { Box, Grid, Container, Typography, CircularProgress } from '@material-ui/core';
import { useRecoilState, useRecoilValue } from 'recoil';
import { userAtom } from 'src/atoms/user';
import React from 'react';
// components
import Page from '../components/Page';
import {
  DisapprovedRequests,
  PendingRequests,
  ApprovedRequests,
  OpenRequests,
  HeatMap
} from '../components/_dashboard/app';
import { snackbarAtom } from 'src/atoms/snackbar';
import axios from 'axios';
import { useNavigate } from 'react-router';
// ----------------------------------------------------------------------
const loaderStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  height: '10%',
  width: '10%',
  display: 'grid',
  placeItems: 'center center'
};
export default function DashboardApp() {
  const user = useRecoilValue(userAtom);
  const [requestsSummary, setRequestsSummary] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  /* eslint-disable no-unused-vars */
  const [snackbar, setSnackbar] = useRecoilState(snackbarAtom);
  const navigate = useNavigate();
  if (user.role === 'DOCTOR') {
    navigate('/dashboard/all-requests');
  }
  React.useEffect(() => {
    async function getData() {
      try {
        const { data: summaryData } = await axios(`/employees/${user.id}/requests_summary`);
        const benRequests = [];
        summaryData.beneficiaries.map((ben) => {
          benRequests.push(...ben.requests);
        });
        setRequestsSummary([...summaryData.requests, ...benRequests]);

        setLoading(false);
      } catch (err) {
        setSnackbar({ severity: 'error', open: true, message: err.message });
        console.log(err);
      }
    }
    if (user.id) getData();
  }, [user]);
  if (loading) {
    return <CircularProgress style={loaderStyle} />;
  }
  return (
    <Page title="Dashboard | Incorta Care">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Hi, Welcome back</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <OpenRequests requestsSummary={requestsSummary} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <PendingRequests requestsSummary={requestsSummary} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <ApprovedRequests requestsSummary={requestsSummary} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DisapprovedRequests requestsSummary={requestsSummary} />
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <HeatMap requestsSummary={requestsSummary} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
